import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    
    // ----------------------------------------------
    // Card

    cardGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gap: theme.spacing(4),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(8),
      [theme.breakpoints.down('sm')]: {
        columnGap: theme.spacing(2.2),
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr)) !important',
        maxWidth: '100%',
        overflowX: 'hidden',
        paddingTop: theme.spacing(3.2),
        rowGap: theme.spacing(5),
        width: '100%',
        '& > section': {
          gridColumn: 'auto !important',
          maxWidth: '100%',
          minWidth: 0,
          width: '100%',
        },
      },
      '@media (max-width: 767px)': {
        columnGap: theme.spacing(2.2),
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr)) !important',
        maxWidth: '100%',
        overflowX: 'hidden',
        paddingTop: theme.spacing(3.2),
        rowGap: theme.spacing(5),
        width: '100%',
        '& > section': {
          gridColumn: 'auto / span 1 !important',
          maxWidth: '100%',
          minWidth: 0,
          width: '100%',
        },
      },

      '& a': {
        color: 'inherit',
        textDecoration: 'inherit',
        '& .MuiCardContent-root': {
          paddingBottom: theme.spacing(1),
        }
      },

    },

    catalogCardGrid: {
      [theme.breakpoints.up('lg')]: {
        '& > section': {
          gridColumn: 'span 4',
        },
      },
      '@media (max-width: 767px)': {
        columnGap: theme.spacing(2.2),
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr)) !important',
        maxWidth: '100%',
        overflowX: 'hidden',
        paddingTop: theme.spacing(3.2),
        rowGap: theme.spacing(5),
        width: '100%',
        '& > section': {
          gridColumn: 'auto / span 1 !important',
          maxWidth: '100%',
          minWidth: 0,
          width: '100%',
        },
      },
    },

    mobileEditorialGrid: {
      [theme.breakpoints.down('sm')]: {
        columnGap: theme.spacing(2.2),
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr)) !important',
        maxWidth: '100%',
        overflowX: 'hidden',
        paddingTop: theme.spacing(3.2),
        rowGap: theme.spacing(5),
        width: '100%',
        '& > section': {
          gridColumn: 'auto / span 1 !important',
          maxWidth: '100%',
          minWidth: 0,
          width: '100%',
        },
      },
      '@media (max-width: 767px)': {
        columnGap: theme.spacing(2.2),
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr)) !important',
        maxWidth: '100%',
        overflowX: 'hidden',
        paddingTop: theme.spacing(3.2),
        rowGap: theme.spacing(5),
        width: '100%',
        '& > section': {
          gridColumn: 'auto / span 1 !important',
          maxWidth: '100%',
          minWidth: 0,
          width: '100%',
        },
      },
    },

    // ----------------------------------------------
    // Empty state

    emptyState: {
      marginTop: theme.spacing(4),
      '& .MuiAlert-message': {
        display: 'grid',
        gap: theme.spacing(1),
      },
    },

    // ----------------------------------------------
    // Pagination

    paginationWrapper: {
      marginTop: theme.spacing(4),

      display: 'grid',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: 'repeat(1, auto)',
      },
      [theme.breakpoints.up('sm')]: {
        gridTemplateColumns: 'repeat(2, auto)',
      },

      width: '100%',
      '& > hr': {
        marginBottom: theme.spacing(4),
      }
    },

    pagination: {
      '& > *': {
        [theme.breakpoints.down('sm')]: {
          justifyContent: 'center',
        },
        [theme.breakpoints.up('sm')]: {
          justifyContent: 'left',
        },
      },
    },

    pageLimit: {
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(4),
        textAlign: 'center',
      },
      [theme.breakpoints.up('sm')]: {
        textAlign: 'right',
      },
      '& > .MuiTextField-root': {
        top: -2
      },
    },

    // ----------------------------------------------

  })
)

export default useStyles
